import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22once-ui.config.ts%22,%22import%22:%22Fragment_Mono%22,%22arguments%22:[{%22variable%22:%22--font-code%22,%22subsets%22:[%22latin%22],%22display%22:%22swap%22,%22weight%22:%22400%22,%22preload%22:false}],%22variableName%22:%22code%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Fragment Mono', 'Fragment Mono Fallback'",
        fontWeight: 400,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
